import React from 'react';
import { motion } from 'framer-motion';
import MarketOverview from '../components/home/MarketOverview';
import CoinTable from '../components/home/CoinTable';
import TrendingBar from '../components/home/TrendingBar';

const HomePage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8">

      <MarketOverview />
      
      <TrendingBar />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="glass-effect rounded-xl p-3 sm:p-6"
      >
        <CoinTable />
      </motion.div>
    </div>
  );
};

export default HomePage;